import { render, staticRenderFns } from "./personListComponent.vue?vue&type=template&id=79880098&scoped=true&"
import script from "./personListComponent.vue?vue&type=script&lang=js&"
export * from "./personListComponent.vue?vue&type=script&lang=js&"
import style0 from "./personListComponent.vue?vue&type=style&index=0&id=79880098&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79880098",
  null
  
)

export default component.exports